/* ============================================================
   straess — theme.js
   Vanilla JS, kein Build-Step nötig. Lädt mit `defer`.
   ============================================================ */
(function () {
  "use strict";

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) =>
    new Intl.NumberFormat("de-CH", { style: "currency", currency: window.Shopify?.currency?.active || "CHF" })
      .format((cents || 0) / 100);

  /* ---------- Header: bei Scroll nach unten verstecken ---------- */
  function initHeader() {
    const header = $("[data-header]");
    if (!header) return;
    let last = 0;
    window.addEventListener(
      "scroll",
      () => {
        const y = window.scrollY;
        header.dataset.hidden = y > 200 && y > last ? "true" : "false";
        last = y;
      },
      { passive: true }
    );
  }

  /* ---------- Mobile Menü ---------- */
  function initMobileMenu() {
    const menu = $("[data-mobile-menu]");
    const open = $("[data-menu-open]");
    const close = $("[data-menu-close]");
    if (!menu || !open) return;
    const toggle = (state) => {
      menu.classList.toggle("is-open", state);
      document.body.style.overflow = state ? "hidden" : "";
    };
    open.addEventListener("click", () => toggle(true));
    close?.addEventListener("click", () => toggle(false));
    $$("a", menu).forEach((a) => a.addEventListener("click", () => toggle(false)));
  }

  /* ---------- Scroll Reveal ---------- */
  function initReveal() {
    const els = $$(".reveal, .reveal-words");
    if (reduced || !("IntersectionObserver" in window)) {
      els.forEach((e) => e.classList.add("is-in"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach((e) => io.observe(e));
  }

  /* ---------- Headline: Wörter in <span> für Reveal ---------- */
  function splitWords() {
    $$("[data-split-words]").forEach((el) => {
      if (el.dataset.done) return;
      const words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words
        .map((w) => `<span class="word"><span>${w}</span></span>`)
        .join(" ");
      el.dataset.done = "1";
    });
  }

  /* ---------- Seitenübergänge: Prefetch + View Transitions ---------- */
  function initPageTransitions() {
    // Prefetch interner Links beim Hover (gefühlte Geschwindigkeit)
    const seen = new Set();
    document.addEventListener(
      "mouseover",
      (e) => {
        const a = e.target.closest && e.target.closest('a[href^="/"]');
        if (!a) return;
        const href = a.getAttribute("href");
        if (!href || seen.has(href) || a.hasAttribute("data-no-prefetch")) return;
        if (a.target === "_blank" || href.startsWith("/cart") || href.includes("?")) return;
        seen.add(href);
        const link = document.createElement("link");
        link.rel = "prefetch";
        link.href = href;
        document.head.appendChild(link);
      },
      { passive: true }
    );

    // Sanfter Fade/Zoom beim Navigieren (View Transitions API, falls verfügbar)
    if (reduced || !document.startViewTransition) return;
    document.addEventListener("click", (e) => {
      const a = e.target.closest && e.target.closest('a[href^="/"]');
      if (!a) return;
      const url = new URL(a.href, location.href);
      if (
        url.origin !== location.origin ||
        a.target === "_blank" ||
        a.hasAttribute("data-no-transition") ||
        e.metaKey || e.ctrlKey || e.shiftKey ||
        url.pathname.startsWith("/cart")
      )
        return;
      e.preventDefault();
      document.startViewTransition(() => {
        window.location.href = a.href;
      });
    });
  }

  /* ---------- Cinematic Showcase (Home: Weiterklicken = Orbit-Video) ---------- */
  function initShowcase() {
    $$("[data-showcase]").forEach((root) => {
      const slides = $$(".showcase__slide", root);
      const idxEl = $(".showcase__index", root);
      const progress = $(".showcase__progress", root);
      if (slides.length < 1) return;
      let i = 0;

      const go = (n) => {
        slides[i].classList.remove("is-active");
        const prevVid = slides[i].querySelector("video");
        if (prevVid) { prevVid.pause(); }
        i = (n + slides.length) % slides.length;
        slides[i].classList.add("is-active");
        const vid = slides[i].querySelector("video");
        if (vid) { vid.currentTime = 0; vid.play().catch(() => {}); }
        if (idxEl) idxEl.textContent = String(i + 1).padStart(2, "0") + " / " + String(slides.length).padStart(2, "0");
        if (progress) progress.style.width = ((i + 1) / slides.length) * 100 + "%";
      };

      $("[data-showcase-next]", root)?.addEventListener("click", () => go(i + 1));
      $("[data-showcase-prev]", root)?.addEventListener("click", () => go(i - 1));
      // Tastatur
      root.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight") go(i + 1);
        if (e.key === "ArrowLeft") go(i - 1);
      });
      go(0);
    });
  }

  /* ---------- Produkt-Galerie (Cinematic, Orbit beim Wechsel) ---------- */
  function initGallery() {
    $$("[data-gallery]").forEach((root) => {
      const items = $$(".gallery__item", root);
      const dots = $$(".gallery__dot", root);
      const thumbs = $$(".gallery__thumb", root);
      if (items.length < 1) return;
      let i = 0;

      // Video eines Items vorab laden (damit der Orbit beim Klick sofort startet)
      const preloadVid = (idx) => {
        const nv = items[(idx + items.length) % items.length]?.querySelector("video");
        if (nv && nv.dataset.preloaded !== "1") { nv.preload = "auto"; nv.load(); nv.dataset.preloaded = "1"; }
      };
      const show = (n, dir) => {
        dir = dir || 1;
        items[i].classList.remove("is-active");
        const old = items[i].querySelector("video");
        if (old) { old.pause(); old.onended = null; old.onerror = null; }
        i = (n + items.length) % items.length;
        items[i].classList.add("is-active");
        const vid = items[i].querySelector("video");
        if (vid) {
          const myItem = items[i];
          // Orbit-Video = nicht-stoppbarer Übergang: läuft EINMAL ab, dann automatisch zum nächsten Bild
          const advance = () => { if (myItem.classList.contains("is-active")) show(i + dir, dir); };
          vid.preload = "auto";
          vid.currentTime = 0;
          vid.onended = advance;
          vid.onerror = advance; // falls das Video nicht abspielt: trotzdem weiter (kein Steckenbleiben)
          vid.play().catch(() => {});
        }
        preloadVid(i + dir); // nächstes Video in Laufrichtung vorab puffern
        dots.forEach((d, k) => d.classList.toggle("is-active", k === i));
        thumbs.forEach((t, k) => t.classList.toggle("is-active", k === i));
      };

      $("[data-gallery-next]", root)?.addEventListener("click", () => show(i + 1, 1));
      $("[data-gallery-prev]", root)?.addEventListener("click", () => show(i - 1, -1));
      thumbs.forEach((t, k) => t.addEventListener("click", () => show(k)));
      dots.forEach((d, k) => d.addEventListener("click", () => show(k)));

      // Swipe auf Mobile
      let sx = 0;
      const stage = $(".gallery__stage", root);
      stage?.addEventListener("touchstart", (e) => (sx = e.touches[0].clientX), { passive: true });
      stage?.addEventListener("touchend", (e) => {
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1, dx < 0 ? 1 : -1);
      }, { passive: true });

      show(0);
    });
  }

  /* ---------- Mass-Flow (Methode wählen → Felder zeigen) ---------- */
  function initFitFlow() {
    const root = $("[data-fit]");
    if (!root) return;
    const erafRadios = $$("input[data-erfassung]", root);
    const erafPanels = $$("[data-erfassung-panel]", root);
    const subRadios = $$("input[data-area]", root);
    const surcharge = $("[data-scan-surcharge]", root);
    const isVisible = (el) => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

    const update = () => {
      // Erfassungsart: manuell vs. 3DLOOK-Scan
      const eraf = erafRadios.find((r) => r.checked)?.dataset.erfassung || "manual";
      erafPanels.forEach((p) => p.classList.toggle("is-active", p.dataset.erfassungPanel === eraf));
      if (surcharge) surcharge.hidden = eraf !== "scan";
      // Pro Bereich: Körpermasse vs. Kleidungsstück
      ["upper", "lower"].forEach((area) => {
        const checked = subRadios.find((r) => r.dataset.area === area && r.checked);
        const sub = checked ? checked.dataset.sub : "body";
        $$('[data-group^="' + area + '-"]', root).forEach((g) =>
          g.classList.toggle("is-active", g.dataset.group === area + "-" + sub)
        );
      });
      // Pflichtfelder nur auf aktuell sichtbaren Feldern (sonst blockiert die Validierung)
      $$("[data-required]", root).forEach((el) => { el.required = isVisible(el); });
    };
    erafRadios.forEach((r) => r.addEventListener("change", update));
    subRadios.forEach((r) => r.addEventListener("change", update));
    update();
  }

  /* ---------- Varianten (Optionen → Variante, Preis, Verfügbarkeit) ---------- */
  function initVariants() {
    const form = $("[data-product-form]");
    if (!form) return;
    const dataEl = $("[data-variants]", form);
    if (!dataEl) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const idInput = form.querySelector('[name="id"]');
    const priceEl = $("[data-price]");
    const btn = form.querySelector('[type="submit"]');
    const label = btn?.querySelector("span");
    const opts = $$("[data-option]", form);
    if (opts.length === 0) return;

    const positions = [...new Set(opts.map((i) => +i.dataset.option))].sort((a, b) => a - b);

    function selected() {
      return positions.map((p) => {
        const c = opts.find((i) => +i.dataset.option === p && i.checked);
        return c ? c.value : null;
      });
    }

    function update() {
      const sel = selected();
      const v = variants.find((va) => va.options.every((o, i) => o === sel[i]));
      if (!v) {
        if (btn) btn.disabled = true;
        if (label) label.textContent = "Nicht verfügbar";
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (btn) btn.disabled = !v.available;
      if (label) label.textContent = v.available ? "In den Warenkorb" : "Ausverkauft";
    }

    opts.forEach((i) => i.addEventListener("change", update));
    update();
  }

  /* ---------- Accordion ---------- */
  function initAccordion() {
    // <details> macht das meiste nativ; hier nur "nur eins offen" optional
  }

  /* ============================================================
     WARENKORB (AJAX) + DRAWER
     ============================================================ */
  const Cart = {
    async get() {
      const r = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      return r.json();
    },
    async add(form) {
      const data = new FormData(form);
      const r = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: data,
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.description || "Konnte nicht hinzugefügt werden.");
      }
      return r.json();
    },
    async addItems(items) {
      const r = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items }),
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.description || "Konnte nicht hinzugefügt werden.");
      }
      return r.json();
    },
    async change(key, quantity) {
      const r = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity }),
      });
      return r.json();
    },
  };

  function renderDrawer(cart) {
    const items = $("[data-drawer-items]");
    const foot = $("[data-drawer-foot]");
    const count = $$("[data-cart-count]");
    count.forEach((c) => {
      c.textContent = cart.item_count;
      c.hidden = cart.item_count === 0;
    });
    if (!items) return;

    if (cart.item_count === 0) {
      items.innerHTML = `<div class="drawer__empty"><p class="muted">Dein Warenkorb ist noch leer.</p><a class="btn btn--accent mt-2" href="/collections/all"><span>Anzüge entdecken</span></a></div>`;
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    items.innerHTML = cart.items
      .map((it) => {
        const props = (it.properties
          ? Object.entries(it.properties).filter(([k]) => k && k[0] !== "_")
          : []
        )
          .map(([k, v]) => `${k}: ${v}`)
          .join(" · ");
        const img = it.image
          ? `<img src="${it.image.replace(/(\.[^.]+)(\?.*)?$/, "_200x$1$2")}" alt="" loading="lazy">`
          : `<div class="placeholder">Bild</div>`;
        return `<div class="line" data-key="${it.key}">
          <div class="line__media">${img}</div>
          <div>
            <div class="line__title">${it.product_title}</div>
            ${it.variant_title && it.variant_title !== "Default Title" ? `<div class="line__props">${it.variant_title}</div>` : ""}
            ${props ? `<div class="line__props">${props}</div>` : ""}
            <div class="line__props">
              <button data-qty="-1" aria-label="weniger">−</button>
              <span style="padding:0 .5rem">${it.quantity}</span>
              <button data-qty="1" aria-label="mehr">+</button>
              <button data-remove style="margin-left:.6rem;text-decoration:underline">entfernen</button>
            </div>
          </div>
          <div class="line__price">${money(it.final_line_price)}</div>
        </div>`;
      })
      .join("");

    const total = $("[data-drawer-total]");
    if (total) total.textContent = money(cart.total_price);

    // Mengen-Events
    $$(".line", items).forEach((line) => {
      const key = line.dataset.key;
      const item = cart.items.find((x) => x.key === key);
      line.querySelectorAll("[data-qty]").forEach((b) =>
        b.addEventListener("click", async () => {
          const next = item.quantity + parseInt(b.dataset.qty, 10);
          renderDrawer(await Cart.change(key, Math.max(0, next)));
        })
      );
      line.querySelector("[data-remove]")?.addEventListener("click", async () => {
        renderDrawer(await Cart.change(key, 0));
      });
    });
  }

  function openDrawer() {
    $("[data-drawer]")?.classList.add("is-open");
    $("[data-drawer-overlay]")?.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    $("[data-drawer]")?.classList.remove("is-open");
    $("[data-drawer-overlay]")?.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function initCart() {
    $("[data-cart-open]")?.addEventListener("click", async (e) => {
      e.preventDefault();
      renderDrawer(await Cart.get());
      openDrawer();
    });
    $("[data-drawer-close]")?.addEventListener("click", closeDrawer);
    $("[data-drawer-overlay]")?.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", (e) => e.key === "Escape" && closeDrawer());

    // Produktformular abfangen
    const form = $("[data-product-form]");
    if (form) {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const note = $("[data-form-error]", form);
        if (note) note.hidden = true;

        // Pflichtfelder prüfen (Masse + Bestätigung)
        if (!form.reportValidity()) return;

        const btn = form.querySelector('[type="submit"]');
        const label = btn?.querySelector("span");
        const orig = label?.textContent;
        if (btn) btn.disabled = true;
        if (label) label.textContent = "Wird hinzugefügt …";

        try {
          // Hauptartikel + Eigenschaften aus dem Formular bauen
          const item = { id: form.querySelector('[name="id"]').value, quantity: 1, properties: {} };
          $$('[name^="properties["]', form).forEach((el) => {
            if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
            if (!el.value) return;
            // Versteckte Felder (inaktive Methode/Bereich) NICHT mitschicken → saubere Bestell-Notiz
            if (el.offsetParent === null) return;
            const key = el.name.slice(11, -1); // properties[Key] -> Key
            item.properties[key] = el.value;
          });

          const items = [item];

          // 3DLOOK-Scan als separate Position dazubuchen
          const scanVariant = $("[data-scan-variant]", form)?.value || form.dataset.scanVariant;
          if (item.properties["Erfassung"] === "3DLOOK AI-Scan" && scanVariant) {
            items.push({
              id: scanVariant,
              quantity: 1,
              properties: { "Gehört zu Anzug": document.title.split("–")[0].trim() },
            });
          }

          await Cart.addItems(items);
          renderDrawer(await Cart.get());
          openDrawer();
          if (label) label.textContent = "Hinzugefügt ✓";
          setTimeout(() => { if (label) label.textContent = orig; }, 1400);
        } catch (err) {
          if (label) label.textContent = orig;
          if (note) { note.textContent = err.message; note.hidden = false; }
          else alert(err.message);
        } finally {
          if (btn) btn.disabled = false;
        }
      });
    }

    // Count beim Laden
    Cart.get().then(renderDrawer).catch(() => {});
  }

  /* ---------- Init ---------- */
  function init() {
    splitWords();
    initHeader();
    initMobileMenu();
    initReveal();
    initPageTransitions();
    initShowcase();
    initGallery();
    initFitFlow();
    initVariants();
    initAccordion();
    initCart();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
